module.exports = __webpack_public_path__ + "static/media/ball-backgroud.d99a0e5c.png";